module.exports = __webpack_public_path__ + "static/assets/14120e6444ca2744dad272d8ca2a4646.svg";